import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DashboardNav from "./dashboardNav";
import Confetti from "react-confetti";
import "./dashboard.css";

function Deposits() {
    const navigate = useNavigate();

    return (
        <>
            <div className="main-bg">
                <div>
                    <DashboardNav active={"deposits"}></DashboardNav>
                </div>
                <div className="load-success">
                    <div>
                        <img src="assets/failed.png" />
                        <h3>Transaction Failed</h3>
                        <p>Please try again after sometime</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Deposits;
